export default __webpack_public_path__ + "static/media/bg-home.bb2eeb61.png";